import React from 'react';
import { Button } from '@material-ui/core';

type WizardButtonVariant = 'outlined' | 'primary' | 'contained';

interface WizardButtonProps {
    variant?: WizardButtonVariant;
    onClick?: () => void;
    disabled?: boolean;
    endIcon?: React.ReactNode;
    fullWidth?: boolean;
    type?: 'button' | 'submit' | 'reset';
    style?: React.CSSProperties;
    className?: string;
    children: React.ReactNode;
}

const PRIMARY_COLOR = '#2ec4b6';
const PRIMARY_DISABLED_COLOR = '#b2ede8';

const variantStyles: Record<
    WizardButtonVariant,
    {
        muiVariant: 'contained' | 'outlined' |'contained';
        muiSize?: 'small' | 'medium';
        muiColor?: 'primary' | 'default';
        style: React.CSSProperties;
    }
> = {
    primary: {
        muiVariant: 'contained',
        muiSize: 'small',
        style: {
            borderRadius: 10,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.9rem',
            color: '#fff'
        }
    },
    outlined: {
        muiVariant: 'outlined',
        muiColor: 'primary',
        style: {
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 500
        }
    },
    contained:{
        muiVariant:"contained",
        muiColor:"primary",
        style:{
            borderRadius: 8,
            color: '#ffffff',
            fontSize: '13px',
            textTransform: 'none'
        }
    },
};

export const WizardButton: React.FC<WizardButtonProps> = ({
    variant = 'primary',
    onClick,
    disabled = false,
    endIcon,
    fullWidth = false,
    type = 'button',
    style,
    className,
    children
}) => {
    const { muiVariant, muiSize, muiColor, style: baseStyle } = variantStyles[variant];

    const primaryBg =
        variant === 'primary'
            ? { backgroundColor: disabled ? PRIMARY_DISABLED_COLOR : PRIMARY_COLOR }
            : {};

    return (
        <Button
            type={type}
            variant={muiVariant}
            size={muiSize}
            color={muiColor}
            fullWidth={fullWidth}
            disabled={disabled}
            onClick={onClick}
            endIcon={endIcon}
            className={className}
            style={{ ...baseStyle, ...primaryBg, ...style }}>
            {children}
        </Button>
    );
};
